/* WMM Animation Kit v1.5 — decorates existing homepage blocks. No IO, timer-driven marquee: works in every context. */
(function(){
  if(!document.querySelector('[class*="ai-video-hero"]'))return; // homepage only
  var reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* hero: wrap words for cut-reveal + underline + embers */
  var name=document.querySelector('[class*="ai-video-hero-company-name"]');
  if(name&&!reduced){
    var words=name.textContent.trim().split(/\s+/);
    var top=words.slice(0,-1).join(' ')||words[0];
    var bottom=words.length>1?words[words.length-1]:'';
    name.innerHTML='<span class="wmm-w"><i>'+top+'</i></span>'+(bottom?'<span class="wmm-w"><i>'+bottom+'</i></span>':'');
    var u=document.createElement('div');u.className='wmm-underline';u.innerHTML='<i></i>';
    name.insertAdjacentElement('afterend',u);
  }
  var heroBg=document.querySelector('[class*="ai-video-hero-background"]');
  var hero=heroBg?heroBg.parentElement:null;
  if(hero&&!reduced){
    var cv=document.createElement('canvas');cv.className='wmm-embers';hero.appendChild(cv);
    var cx=cv.getContext('2d'),W,H,P=[];
    var size=function(){W=cv.width=cv.offsetWidth;H=cv.height=cv.offsetHeight};size();addEventListener('resize',size);
    for(var i=0;i<30;i++)P.push({x:Math.random()*1800,y:Math.random()*1000,r:Math.random()*1.7+.4,vy:Math.random()*.45+.12,vx:(Math.random()-.5)*.2,o:Math.random()*.5+.12,hot:Math.random()<.3});
    setInterval(function(){cx.clearRect(0,0,W,H);for(var j=0;j<P.length;j++){var p=P[j];p.y-=p.vy;p.x+=p.vx;if(p.y<-8){p.y=H+8;p.x=Math.random()*W}cx.beginPath();cx.arc(p.x%W,p.y,p.r,0,7);cx.fillStyle=p.hot?'rgba(255,162,62,'+p.o+')':'rgba(124,196,255,'+(p.o*.65)+')';cx.fill()}},33);
  }
  var arm=function(){document.documentElement.classList.add('wmm-ready')};requestAnimationFrame(arm);addEventListener('load',arm);setTimeout(arm,1200);

  /* laser dividers between top-level home blocks */
  var mainEl=document.querySelector('main');
  if(mainEl){
    var blocks=mainEl.querySelectorAll('[class*="ai-dual-column-container"],[class*="ai-laser-services-container"],[class*="ai-gallery-cta-container"]');
    blocks.forEach(function(b){var d=document.createElement('div');d.className='wmm-divider';d.innerHTML='<i></i>';b.parentElement.insertBefore(d,b)});
  }

  /* etched ridge svg into each dual-column text block */
  var ETCH='<svg class="wmm-etch" viewBox="0 0 360 100" aria-hidden="true"><path class="wmm-fill" d="M0 96 L60 40 L92 74 L128 18 L168 60 L204 30 L252 86 L300 52 L360 96 L360 100 L0 100 Z"/><path d="M0 96 L60 40 L92 74 L128 18 L168 60 L204 30 L252 86 L300 52 L360 96"/><path class="wmm-snow" d="M118 34 L128 18 L138 34 M194 44 L204 30 L214 44"/><circle class="wmm-tip" r="3"/></svg>';
  document.querySelectorAll('[class*="ai-dual-column-content"]').forEach(function(c){c.insertAdjacentHTML('afterbegin',ETCH)});

  /* wipes: alternate directions across dual images; laser image wipes up */
  var dirs=['wmm-wl','wmm-wr','wmm-wu','wmm-wd'];
  document.querySelectorAll('[class*="ai-dual-column-image-wrapper"]').forEach(function(w,i){w.classList.add('wmm-wipe',dirs[i%4])});
  document.querySelectorAll('[class*="ai-laser-services-image-wrapper"]').forEach(function(w){w.classList.add('wmm-wipe','wmm-wu')});

  /* reveal targets */
  document.querySelectorAll('[class*="ai-dual-column-item"],[class*="ai-laser-services-content"],[class*="ai-gallery-cta-content"]').forEach(function(el){el.classList.add('wmm-rv')});

  /* universal rect-scan trigger */
  var pending=Array.prototype.slice.call(document.querySelectorAll('.wmm-rv,.wmm-divider,.wmm-wipe'));
  function scan(){
    if(!pending.length)return;
    var vh=window.innerHeight;
    pending=pending.filter(function(t){
      var r=t.getBoundingClientRect();
      if(r.top<vh*.85&&r.bottom>0){
        t.classList.add(t.classList.contains('wmm-divider')?'wmm-lit':'wmm-in');
        return false;
      }
      return true;
    });
  }
  addEventListener('scroll',scan,{passive:true});
  addEventListener('resize',scan);
  setInterval(scan,400);
  scan();

  /* gallery marquee: original 5-up strip, whip-in fast then steady drift */
  var cta=document.querySelector('[class*="ai-gallery-cta-container"]');
  var wrap=cta?cta.querySelector('[class*="ai-gallery-carousel-wrapper"]'):null;
  var track=null;
  if(wrap){
    var cands=wrap.querySelectorAll('[class*="ai-gallery-carousel"]');
    for(var k=0;k<cands.length;k++){if(!/wrapper/.test(cands[k].className)&&cands[k].children.length>=3){track=cands[k];break}}
    if(!track){for(var m=0;m<wrap.children.length;m++){if(wrap.children[m].children.length>=3){track=wrap.children[m];break}}}
  }
  if(cta&&wrap&&track&&!reduced){
    cta.classList.add('wmm-cine');
    track.classList.add('wmm-track');
    wrap.querySelectorAll('button').forEach(function(b){b.style.display='none'});
    var GAP=16, VISIBLE=5;
    var originals=Array.prototype.slice.call(track.children);
    function sizeTiles(){
      var w=(wrap.clientWidth-(VISIBLE-1)*GAP)/VISIBLE;
      if(window.innerWidth<750){w=(wrap.clientWidth-GAP)/2}
      Array.prototype.forEach.call(track.children,function(t){t.style.width=w+'px';t.style.height=Math.round(w*.95)+'px'});
    }
    var guard=0;
    while(track.children.length<originals.length*4&&guard<40){
      originals.forEach(function(o){track.appendChild(o.cloneNode(true))});guard++;
    }
    sizeTiles();addEventListener('resize',sizeTiles);
    var x=0,t0=null,setW=1,paused=false,seen=false,last=null;
    function setWidth(){var half=track.scrollWidth/2;setW=half>0?half:1}
    setWidth();addEventListener('resize',setWidth);
    var FAST=520,STEADY=42,TAU=900;
    setInterval(function(){
      var now=performance.now();
      if(!seen){
        var r=wrap.getBoundingClientRect();
        if(r.top<window.innerHeight&&r.bottom>0){seen=true;t0=null;last=null;setWidth()}
        return;
      }
      if(paused){last=now;return}
      if(t0===null)t0=now;
      if(last===null)last=now;
      var dt=Math.min(.06,(now-last)/1000);last=now;
      var v=STEADY+(FAST-STEADY)*Math.exp(-(now-t0)/TAU);
      x-=v*dt;
      if(-x>=setW)x+=setW;
      track.style.transform='translateX('+x+'px)';
    },16);
    cta.addEventListener('mouseenter',function(){paused=true});
    cta.addEventListener('mouseleave',function(){paused=false});
  }
})();
